import React, { FC } from "react";
import { PurchaseInfoList } from "./PurchaseInfoList/PurchaseInfoList";
import { AdditionalInformation } from "./AdditionalInformation/AdditionalInformation";
import { useAppSelector } from "../../../../store/reduxHooks";
import { SELECT_APPLICATIONS_DATA_TO_BANK } from "../../../../store/selectors/applicationDataToBankSelector";

export const Questionnaire: FC = () => {
  const data = useAppSelector(SELECT_APPLICATIONS_DATA_TO_BANK);
  return (
    <div>
      {data && <PurchaseInfoList data={data} />}
      <AdditionalInformation />
    </div>
  );
};
